import PropTypes from "prop-types";

export const RowType = {
	children: PropTypes.node.isRequired
};
